import { createContext, useContext, useEffect, useState } from 'react';

/**
 * Panelets ene breakpoint (DD-51): på og under `--innspel-layout-breakpoint-smal` er skjermen
 * «smal» — én kolonne og topplinje. Grensen leses fra tokens.css så den bor ett sted; en
 * `@media`-betingelse kan ikke lese en variabel, derfor måles den her med matchMedia
 * (samme mønster som portalens Dialog.tsx). Finnes ikke variabelen eller matchMedia, er
 * skjermen bred. Skallet setter klassen `panel-smal`; resten av panelet leser konteksten.
 */
export function useSmalSkjerm(): boolean {
  const [smal, setSmal] = useState(false);
  useEffect(() => {
    if (typeof matchMedia !== 'function') return;
    const grense = getComputedStyle(document.documentElement).getPropertyValue('--innspel-layout-breakpoint-smal').trim();
    if (!grense) return;
    const mq = matchMedia(`(max-width: ${grense})`);
    const oppdater = () => setSmal(mq.matches);
    oppdater();
    mq.addEventListener('change', oppdater);
    return () => mq.removeEventListener('change', oppdater);
  }, []);
  return smal;
}

const Kontekst = createContext(false);

export const SmalSkjermProvider = Kontekst.Provider;

/** Skjermen slik skallet har målt den. Utenfor skallet (innlogging, tofaktor) er den bred. */
export function useSmal(): boolean {
  return useContext(Kontekst);
}
